var layoutTemplate = require('@/modules/components/lora/short-video.handlebars')
import { SHORT_VIDEO_API } from '@/configs/api'
import { OVERLAY_TYPE, PLAYLIST_TYPE, SHORT_VIDEO_TRACKING_TYPE, VIDEO_STATUS } from '@/configs/constants'
import { DEFAULT_CTA_TEXT, DEFAULT_CTA_BTN } from '@/configs/default'
import { STATUS_RESPONSES } from '@/configs/settings'
import GlobalSettings from '@/core/global-settings'
import httpResources from '@/libs/axios'
import shopifyCart from '~/services/shopify-cart'
import manualCart from '~/services/manual-cart'
import { appendCommonStyling } from '~/helpers'
import { META_ID } from '@/configs/analytics'
import { ANALYTICS_EVENT } from '@/configs/analytics'
import { emitShortVideoEvent, SHORT_VIDEO_EVENT_NAMES } from '@/core/short-video-events'
import EventManager from '@/core/event-manager'
import { ECOMMERCE_SITE, MANUAL_CART_EVENTS, DEFAULT_MIN_HEIGHT_TO_SHOW_BTN } from '@/configs/settings'
import { getPlaylistData } from '~/store/playlist'
import { v4 as uuidv4 } from 'uuid'
import { isVideoLiked, unlikeVideo, likeVideo } from '@/services/db'
class LoraShortVideo extends HTMLElement {
    static get observedAttributes() {
        return [
            'autoplay',
            'item-width',
            'no-action-hover',
            'fullscreen',
            'loop',
            'muted',
            'video-height',
            'polling-selected',
            'group',
            'simple',
            'lazyload',
            'custom-height',
            'video-type',
            'prev-index',
            'next-index',
            'display-style',
            'enable-fullscreen',
            'pip-style',
            'active-index',
            'uuid',
            'disable-tracking',
            'tag-name',
            'organization-id',
            'fs-force-new-tab',
            'min-h-btns',
            'enable-like-button',
            'display-like-count',
            'total-like',
        ]
    }
    constructor() {
        super()
        this.attachShadow({ mode: 'open' })
        this.httpInstance = GlobalSettings.httpInstance || httpResources
        this.eventManager = new EventManager()
        this.baseTrackingUrl = process.env.BASE_API // Using default is current tracking system
        this.trackingUrl = SHORT_VIDEO_API.TRACK_IOT // Using default is current tracking system
        this.videoItem = null
        this.videoId = null
        // POLL
        this.resultPoll = null
        this.answered = false
        this.pollingSelected = null
        this._shortVideo = null
        this._pendingShortVideoAttrs = []

        // Q&A
        this.answeredFollowupQuestion = null
        this.answeredDefaultQuestion = null

        // Elements
        this.playlistType = null
        this.videoType = null
        this.displayStyle = 'block'

        this.lazyLoad = true

        this.disabledButtonAnswer = false

        this.videoPercentTracked = []
        this.videoPercentTrackedGoogle = []
        this.isRegistered = false
        this.isListeningEvents = false
        this.isRegisterEvents = false
        this.isSyncingProduct = false
        this.pipStyle = ''
        this.activeIndex = 0
        this.uuid = null
        this.organizationId = null
        this.customTagName = ''
        this.isLikedVideo = false
        this.currentUser = {}
    }

    async connectedCallback() {
        this.shadowRoot.addEventListener('sv-load', (e) => {
            e.stopImmediatePropagation()
            this.publishLoraEvents(SHORT_VIDEO_EVENT_NAMES.ON_LOAD)
        })
        this.getInitialData()
        if (!this.lazyLoad) {
            await this.fetchData()
        } else {
            this.render()
        }
    }

    disconnectedCallback() {}

    attributeChangedCallback(name, oldValue, newValue) {
        switch (name) {
            case 'display-style': {
                if (newValue !== null) {
                    this.displayStyle = newValue
                }
                requestAnimationFrame(() => {
                    this.updateShortVideoAttribute('display-style', this.displayStyle)
                })
            }
            case 'item-width': {
                if (newValue !== null) {
                    this.itemWidth = parseFloat(newValue)
                }
                requestAnimationFrame(() => {
                    this.updateShortVideoAttribute('item-width', this.itemWidth)
                })
                break
            }
            case 'autoplay': {
                if (newValue !== null) {
                    this.autoplay = true
                } else {
                    this.autoplay = false
                }
                requestAnimationFrame(() => {
                    this.updateShortVideoAttribute('autoplay', this.autoplay)
                })
                break
            }
            case 'enable-fullscreen': {
                if (newValue !== null && newValue !== 'false') {
                    this.enableFullscreen = true
                } else {
                    this.enableFullscreen = false
                }
                requestAnimationFrame(() => {
                    this.updateShortVideoAttribute('enable-fullscreen', this.enableFullscreen)
                })
            }
            case 'prev-index': {
                this.prevIndex = parseInt(newValue)
                requestAnimationFrame(() => {
                    this.updateShortVideoAttribute('prev-index', this.prevIndex)
                })
                break
            }
            case 'next-index': {
                this.nextIndex = parseInt(newValue)
                requestAnimationFrame(() => {
                    this.updateShortVideoAttribute('next-index', this.nextIndex)
                })
                break
            }
            case 'fullscreen': {
                if (newValue !== null) {
                    this.isFullscreen = true
                } else {
                    this.isFullscreen = false
                }
                requestAnimationFrame(() => {
                    this.updateShortVideoAttribute('fullscreen', this.isFullscreen)
                })
                break
            }
            case 'fs-force-new-tab': {
                if (newValue !== null && newValue !== 'false') {
                    this.isForceNewTab = true
                } else {
                    this.isForceNewTab = false
                }
                requestAnimationFrame(() => {
                    this.updateShortVideoAttribute('fs-force-new-tab', this.isForceNewTab)
                })
                break
            }
            case 'no-action-hover': {
                if (newValue !== null) {
                    this.noActionHover = true
                } else {
                    this.noActionHover = false
                }
                requestAnimationFrame(() => {
                    this.updateShortVideoAttribute('no-action-hover', this.noActionHover)
                })
                break
            }
            case 'loop': {
                if (newValue !== null && newValue !== 'false') {
                    this.loop = true
                } else {
                    this.loop = false
                }
                requestAnimationFrame(() => {
                    this.updateShortVideoAttribute('loop', this.loop)
                })
                break
            }

            case 'lazyload': {
                if (newValue !== null && newValue !== 'false') {
                    this.lazyload = true
                } else {
                    this.lazyload = false
                    this.fetchData(true)
                }
                break
            }
            case 'custom-height': {
                if (newValue !== null && newValue !== 'false') {
                    this.customHeight = true
                } else {
                    this.customHeight = false
                }
                requestAnimationFrame(() => {
                    this.updateShortVideoAttribute('custom-height', this.customHeight)
                })
                break
            }
            case 'muted': {
                if (newValue == 'false') {
                    this.muted = true
                } else {
                    this.muted = false
                }
                requestAnimationFrame(() => {
                    this.updateShortVideoAttribute('muted', this.muted, true)
                })
                break
            }
            case 'video-height': {
                if (newValue) {
                    this.videoHeight = newValue
                }
                requestAnimationFrame(() => {
                    this.updateShortVideoAttribute('video-height', this.videoHeight ? `${this.videoHeight}` : '480px')
                })
                break
            }
            case 'polling-selected': {
                if (newValue && newValue !== oldValue) {
                    this.pollingSelected = newValue
                    requestAnimationFrame(() => {
                        this.updateShortVideoAttribute('polling-selected', newValue)
                    })
                }
            }
            case 'group': {
                if (newValue !== null) {
                    this.group = true
                } else {
                    this.group = 'general'
                }
                requestAnimationFrame(() => {
                    this.updateShortVideoAttribute('group', this.group)
                })
                break
            }
            case 'simple': {
                if (newValue !== null) {
                    this.isSimple = true
                } else {
                    this.isSimple = false
                }
                requestAnimationFrame(() => {
                    this.updateShortVideoAttribute('simple', this.isSimple)
                })
                break
            }
            case 'video-type': {
                requestAnimationFrame(() => {
                    this.updateShortVideoAttribute('video-type', newValue)
                })
                break
            }
            case 'pip-style': {
                requestAnimationFrame(() => {
                    this.updateShortVideoAttribute('pip-style', newValue)
                })
                break
            }
            case 'active-index': {
                requestAnimationFrame(() => {
                    this.updateShortVideoAttribute('active-index', newValue)
                })
                break
            }
            case 'uuid': {
                this.uuid = newValue
                requestAnimationFrame(() => {
                    this.updateShortVideoAttribute('uuid', newValue)
                })
                break
            }
            case 'disable-tracking': {
                requestAnimationFrame(() => {
                    this.updateShortVideoAttribute('disable-tracking', newValue)
                })
                break
            }
            case 'tag-name': {
                this.customTagName = newValue
                requestAnimationFrame(() => {
                    this.updateShortVideoAttribute('tag-name', newValue, true)
                })
                break
            }
            case 'organization-id': {
                this.organizationId = newValue
                requestAnimationFrame(() => {
                    this.updateShortVideoAttribute('organization-id', newValue)
                })
                break
            }

            case 'min-h-btns': {
                this.minVideoHeightToShowButtons = newValue
                requestAnimationFrame(() => {
                    this.updateShortVideoAttribute('min-h-btns', newValue || DEFAULT_MIN_HEIGHT_TO_SHOW_BTN)
                })
                break
            }

            case 'enable-like-button': {
                if (newValue !== null && newValue !== 'false') {
                    this.enableLikeButton = true
                } else {
                    this.enableLikeButton = false
                }
                requestAnimationFrame(() => {
                    this.updateShortVideoAttribute('enable-like-button', this.enableLikeButton)
                })
                break
            }

            case 'display-like-count': {
                if (newValue !== null && newValue !== 'false') {
                    this.displayLikeCount = true
                } else {
                    this.displayLikeCount = false
                }
                requestAnimationFrame(() => {
                    this.updateShortVideoAttribute('display-like-count', this.displayLikeCount)
                })
                break
            }

            case 'total-like': {
                this.totalLike = parseInt(newValue)
                requestAnimationFrame(() => {
                    this.updateShortVideoAttribute('total-like', this.totalLike)
                })
                break
            }
        }
    }

    // Method to determine visibility of buttons
    updateButtonVisibility() {}

    setBaseInfo() {
        if (!this._shortVideo) {
            this._shortVideo = this.shadowRoot.querySelector('b-short-video')
        }
        const baseData = {
            baseElement: this._shortVideo ? this._shortVideo : this,
            videoId: this.videoId,
            playlistId: this.playlistId,
            eventManager: this.eventManager,
        }
        if (this.videoItem.ecommerceSite?.value === ECOMMERCE_SITE.SHOPIFY) {
            shopifyCart.setBaseInfo(baseData)
        } else if (this.videoItem.ecommerceSite?.value === ECOMMERCE_SITE.OTHER) {
            manualCart.setBaseInfo(baseData, this.videoId, this.playlistId)
        }
    }

    setVideoData(isPreload = true) {
        this.isPreload = isPreload
        if (!this._shortVideo) {
            this._shortVideo = this.shadowRoot.querySelector('b-short-video')
        }
        if (this._shortVideo) {
            this._shortVideo.updateVideoData({
                url: this.videoItem?.videoFile,
                isPreload: this.isPreload,
                enableLikeButton: this.enableLikeButton,
                displayLikeCount: this.displayLikeCount,
                totalLike: this.totalLike,
                isLikedVideo: this.isLikedVideo,
            })
            requestAnimationFrame(() => {
                this.updateShortVideoAttribute('lazyload', false)
                this.updateShortVideoAttribute('enable-like-button', this.enableLikeButton)
                this.updateShortVideoAttribute('display-like-count', this.displayLikeCount)
                this.updateShortVideoAttribute('total-like', this.totalLike)
            })
            this.registerEvents()
        }
    }

    /**
     * Set attribute on <b-short-video>, waiting if necessary.
     */
    updateShortVideoAttribute(attributeName, data, forceToString = false) {
        if (!this._shortVideo) {
            // Try finding it immediately
            this._shortVideo = this.shadowRoot.querySelector('b-short-video')
        }

        if (!this._shortVideo) {
            // Queue the update and start observer
            this._pendingShortVideoAttrs.push({ attributeName, data, forceToString })
            this._waitForShortVideo()
            return
        }

        // Log for debugging
        if (attributeName === 'video-type') {
            console.log('DEBUG: video-type', {
                data,
                shortVideo: this._shortVideo,
            })
        }

        // Apply attribute
        this._applyAttribute(attributeName, data, forceToString)
    }

    /**
     * Internal: apply an attribute or remove if null/undefined
     */
    _applyAttribute(attributeName, data, forceToString) {
        if (!this._shortVideo) return

        if (data) {
            this._shortVideo.setAttribute(attributeName, forceToString ? `${data}` : data)
        } else {
            this._shortVideo.removeAttribute(attributeName)
        }
    }

    /**
     * Internal: wait for b-short-video to be added to the DOM
     */
    _waitForShortVideo() {
        if (this._waitingForShortVideo) return // Avoid duplicate observers
        this._waitingForShortVideo = true

        const observer = new MutationObserver(() => {
            const el = this.shadowRoot.querySelector('b-short-video')
            if (el) {
                observer.disconnect()
                this._shortVideo = el
                this._waitingForShortVideo = false

                // Flush queued updates
                this._pendingShortVideoAttrs.forEach(({ attributeName, data, forceToString }) => {
                    this._applyAttribute(attributeName, data, forceToString)
                })
                this._pendingShortVideoAttrs = []
            }
        })

        observer.observe(this.shadowRoot, { childList: true, subtree: true })
    }

    getInitialData() {
        this.videoId = this.getAttribute('video-id')
        this.loop = this.hasAttribute('loop') && this.getAttribute('loop') !== 'false' ? true : false
        this.currentIndex = this.getAttribute('data-index') ? parseInt(this.getAttribute('data-index')) : 0

        this.prevIndex = this.getAttribute('prev-index') ? parseInt(this.getAttribute('prev-index')) : 0

        this.nextIndex = this.getAttribute('next-index') ? parseInt(this.getAttribute('next-index')) : 0

        this.isFullscreen = this.getAttribute('fullscreen') !== null ? true : false
        this.isForceNewTab =
            this.hasAttribute('fs-force-new-tab') && this.getAttribute('fs-force-new-tab') !== 'false' ? true : false

        // Video opitons:
        this.autoplay = this.getAttribute('autoplay') !== null ? true : false

        this.itemWrapper = this.getAttribute('item-wrapper') ? this.getAttribute('item-wrapper') : ''
        this.gutters = this.getAttribute('gutters') ? parseFloat(this.getAttribute('gutters')) : 10
        this.itemWidth = this.getAttribute('item-width') ? parseFloat(this.getAttribute('item-width')) : 0
        this.wrapperLayout = this.getAttribute('wrapper') ? this.getAttribute('wrapper') : 'b-short-video'
        this.playlistId =
            this.wrapperLayout !== 'b-short-video'
                ? this.shadowRoot?.host?.getRootNode()?.host.getAttribute('playlist-id')
                : this.getAttribute('playlist-id')
        this.group = this.getAttribute('group') ? this.getAttribute('group') : 'general'

        this.videoHeight = this.getAttribute('video-height') ? this.getAttribute('video-height') : '480px'
        this.url = this.getAttribute('url')
        this.title = this.getAttribute('title')
        this.thumbnail = this.getAttribute('thumbnail')
        this.displayStyle = this.getAttribute('display-style') || 'block'
        this.generality = this.getAttribute('generality') !== null ? true : false
        this.ctaMode = this.getAttribute('cta')
        this.muted = this.getAttribute('muted') == 'false' ? false : true
        this.enableFullscreen = this.getAttribute('enable-fullscreen') == 'false' ? false : true
        this.isSimple = this.getAttribute('simple') !== null ? true : false
        this.isStory = this.getAttribute('story') !== null ? true : false
        this.noActionHover = this.getAttribute('no-action-hover') !== null ? true : false
        this.lazyLoad = this.getAttribute('lazyload') !== null ? true : false
        this.useCustomHeight = this.getAttribute('custom-height') !== null ? true : false
        this.pipStyle = this.getAttribute('pip-style') || 'bottom: 0px; right: 15px;'
        const wrapper = this.getAttribute('wrapper')
        this.uuid = this.getAttribute('uuid') || uuidv4()
        this.organizationId = this.getAttribute('organization-id') ? parseInt(this.getAttribute('organization-id')) : 0
        this.customTagName = this.getAttribute('tag-name') || this.shadowRoot.host.tagName
        this.minVideoHeightToShowButtons = this.getAttribute('min-h-btns') || DEFAULT_MIN_HEIGHT_TO_SHOW_BTN

        if (wrapper) {
            this.playlistType = wrapper.includes('carousel')
                ? PLAYLIST_TYPE.CAROUSEL
                : wrapper.includes('grid')
                ? PLAYLIST_TYPE.GRID
                : wrapper.includes('story-block')
                ? PLAYLIST_TYPE.STORY_BLOCK
                : ''
        }
        if (GlobalSettings.isUseNewTracking) {
            // Using new tracking system
            this.baseTrackingUrl = `${process.env.TRACKING_ENDPOINT}/api`
            this.trackingUrl = SHORT_VIDEO_API.TRACK_IOT
        }
    }

    async registerEvents() {
        if (this.isRegisterEvents) {
            return
        }
        this.videoElement = this.shadowRoot.querySelector('video')
        this._shortVideo = this.shadowRoot.querySelector('b-short-video')
        requestAnimationFrame(() => {
            this.updateShortVideoAttribute('item-width', this.itemWidth)
            this.updateShortVideoAttribute('autoplay', this.autoplay)
            this.updateShortVideoAttribute('fullscreen', this.isFullscreen)
            this.updateShortVideoAttribute('fs-force-new-tab', this.isForceNewTab)
            this.updateShortVideoAttribute('enable-fullscreen', this.enableFullscreen)
            this.updateShortVideoAttribute('no-action-hover', this.noActionHover)
            this.updateShortVideoAttribute('loop', this.loop)
            this.updateShortVideoAttribute('muted', this.muted, true)
            this.updateShortVideoAttribute('video-height', this.videoHeight ? `${this.videoHeight}` : '480px')
            this.updateShortVideoAttribute('polling-selected', this.pollingSelected)
            this.updateShortVideoAttribute('group', this.group)
            this.updateShortVideoAttribute('simple', this.isSimple)
            this.updateShortVideoAttribute('pip-style', this.pipStyle)
            this.updateShortVideoAttribute('enable-like-button', this.enableLikeButton)
            this.updateShortVideoAttribute('display-like-count', this.displayLikeCount)
            this.updateShortVideoAttribute('total-like', this.totalLike)
        })
        if (this.videoItem) {
            this._shortVideo.videoItem = this.videoItem
        }
        if (this.videoItem?.overlayType === OVERLAY_TYPE.CTA) {
            // Update CTA data
            this.updateCTA()
        } else if (this.videoItem?.overlayType === OVERLAY_TYPE.POLLING) {
            // Update POLLING data
            await this.checkViewerAnswerPoll()
            this.updatePoll()
        } else if (this.videoItem?.overlayType === OVERLAY_TYPE.QUESTION_AND_ANSWER) {
            // Update Question and Answer data
            await this.checkViewerAnswerQuestion()
            this.updateQuestionAndAnswer()
        }
        this.registerTracking()
        this.handleInternalEvents()
        this.wrapperContainer = this.shadowRoot.host
        if (this.wrapperLayout !== 'b-short-video') {
            this.wrapperContainer = this.shadowRoot.host.getRootNode().host
        }
        this.isRegisterEvents = true
    }

    async onCheckPollAndUpdate() {
        await this.checkViewerAnswerPoll()
        this.updatePoll()
    }

    async onCheckQaAndUpdate() {
        setTimeout(async () => {
            await this.checkViewerAnswerQuestion()
            this.updateQuestionAndAnswer()
            if (!this.videoItem.overlayData.requiredFollowupInfo && !this.answeredFollowupQuestion) {
                this._shortVideo.showThankModal()
            } else if (this.videoItem.overlayData.requiredFollowupInfo && !this.answeredFollowupQuestion) {
                this._shortVideo.showFollowUpQuestionSyncState()
            } else if (this.videoItem.overlayData.requiredFollowupInfo && this.answeredFollowupQuestion) {
                this._shortVideo.showThankModal()
            }
        }, 500)
    }

    updateCTA() {
        let shopCTA = DEFAULT_CTA_TEXT.filter((item) => item.value === this.videoItem.shopCTA)[0]
        this._shortVideo.ctaDetail = {
            backgroundColor: this.videoItem.backgroundColor,
            useCartIntegration: this.videoItem.useCartIntegration,
            textColor: this.videoItem.textColor,
            products: this.videoItem.products,
            urlName: shopCTA ? shopCTA.name : DEFAULT_CTA_BTN,
            isLoading: this.isSyncingProduct,
        }
    }

    updatePoll() {
        if (!this.videoItem.overlayData) return
        this._shortVideo.pollDetail = {
            bgColor: this.videoItem.overlayData.backgroundColor,
            textColor: this.videoItem.overlayData.textColor,
            options: this.videoItem.overlayData.options,
            title: this.videoItem.overlayData.title,
            result: this.resultPoll,
        }
        this._shortVideo.addEventListener('poll-submitted', (data) => {
            if (this.pollingSelected) return
            this.pollingSelected = data.detail.selected
            this.submitPoll()
        })
    }

    updateQuestionAndAnswer() {
        if (!this.videoItem.overlayData) return
        const notAnswerDefaultQuestion = !this.answeredDefaultQuestion
        const shouldShowFollowUpQuestion =
            this.answeredDefaultQuestion &&
            !this.answeredFollowupQuestion &&
            this.videoItem.overlayData.requiredFollowupInfo

        this._shortVideo.qaDetail = {
            bgColor: this.videoItem.overlayData.backgroundColor,
            textColor: this.videoItem.overlayData.textColor,
            questionFollowup: this.videoItem.overlayData.questionFollowup,
            questionDefault: this.videoItem.overlayData.questionDefault,
            notAnswerDefaultQuestion,
            shouldShowFollowUpQuestion,
            submitted: !notAnswerDefaultQuestion && !shouldShowFollowUpQuestion,
        }
        this._shortVideo.addEventListener('qa-answer-clicked', () => {})
        this._shortVideo.addEventListener('qa-answered-question', (data) => {
            if (this.disabledButtonAnswer) {
                return
            }
            this.disabledButtonAnswer = true
            this.trackingIOT(SHORT_VIDEO_TRACKING_TYPE.QNA_CLICK)
            if (!this.answeredDefaultQuestion) {
                this.sendAnswerForDefaultQuestion(data.detail.answer)
            } else {
                this.sendAnswerForFollowUpQuestion(data.detail.answer)
            }
            if (!this.isFullscreen) return
            this.dispatchEvent(
                new CustomEvent('sync-state-poll-qna', {
                    detail: {
                        qa: data.detail.answer || {},
                        qaDetail: {
                            ...this._shortVideo.qaDetail,
                        },
                        id: this.videoId,
                        playlistId: this.playlistId,
                        index: this.currentIndex.toString() || null,
                    },
                    composed: true,
                    bubbles: true,
                })
            )
        })
    }

    handleInternalEvents() {
        if (this.isListeningEvents) {
            return
        }
        this.eventManager.on(MANUAL_CART_EVENTS.SYNCED_PRODUCT, (data) => {
            if (this.videoItem?.overlayType === OVERLAY_TYPE.CTA) {
                this.videoItem.products = data
                this.isSyncingProduct = false
                // Update CTA data
                this.updateCTA()
            }
        })
        // Manual cart
        if (!this._shortVideo) {
            this._shortVideo = this.shadowRoot.querySelector('b-short-video')
        }
        this._shortVideo.eventManager.on(MANUAL_CART_EVENTS.SYNC_PRODUCT, (data, callback) => {
            this.eventManager.emit(MANUAL_CART_EVENTS.SYNC_PRODUCT, data, callback)
        })

        this._shortVideo.eventManager.on(MANUAL_CART_EVENTS.ADD_TO_CART, (data, callback) => {
            this.eventManager.emit(MANUAL_CART_EVENTS.ADD_TO_CART, data, callback)
        })

        this._shortVideo.eventManager.on(MANUAL_CART_EVENTS.UPDATE_ITEM_IN_CART, (data, callback) => {
            this.eventManager.emit(MANUAL_CART_EVENTS.UPDATE_ITEM_IN_CART, data, callback)
        })

        this._shortVideo.eventManager.on(MANUAL_CART_EVENTS.SYNC_CART_STATE, (data, callback) => {
            this.eventManager.emit(MANUAL_CART_EVENTS.SYNC_CART_STATE, data, callback)
        })

        this._shortVideo.eventManager.on(MANUAL_CART_EVENTS.CHECKOUT, (data, callback) => {
            this.eventManager.emit(MANUAL_CART_EVENTS.CHECKOUT, data, callback)
        })

        this.eventManager.on(SHORT_VIDEO_EVENT_NAMES.OPEN_CART, (data) => {
            this.publishLoraEvents(SHORT_VIDEO_EVENT_NAMES.OPEN_CART, data)
        })
        this.eventManager.on(SHORT_VIDEO_EVENT_NAMES.CLOSE_CART, (data) => {
            this.publishLoraEvents(SHORT_VIDEO_EVENT_NAMES.CLOSE_CART, data)
        })
        this.eventManager.on(SHORT_VIDEO_EVENT_NAMES.ADD_TO_CART, (data) => {
            this.publishLoraEvents(SHORT_VIDEO_EVENT_NAMES.ADD_TO_CART, data)
        })
        this.eventManager.on(SHORT_VIDEO_EVENT_NAMES.DECREASE_FROM_CART, (data) => {
            this.publishLoraEvents(SHORT_VIDEO_EVENT_NAMES.DECREASE_FROM_CART, data)
        })
        this.eventManager.on(SHORT_VIDEO_EVENT_NAMES.CHECKOUT, (data) => {
            this.publishLoraEvents(SHORT_VIDEO_EVENT_NAMES.CHECKOUT, data)
        })
        this.eventManager.on(SHORT_VIDEO_EVENT_NAMES.REMOVE_FROM_CART, (data) => {
            this.publishLoraEvents(SHORT_VIDEO_EVENT_NAMES.REMOVE_FROM_CART, data)
        })
        this.isListeningEvents = true
    }

    registerTracking() {
        if (this.isRegistered) {
            return
        }
        this.handleInternalEvents()
        this.shadowRoot.addEventListener('tracking-view', (e) => {
            e.stopImmediatePropagation()
            this.trackingIOT(SHORT_VIDEO_TRACKING_TYPE.VIEW, e?.detail || {})
        })

        this.shadowRoot.addEventListener('tracking-view-percent', (e) => {
            e.stopImmediatePropagation()
            this.trackingMetaPixel(SHORT_VIDEO_TRACKING_TYPE.VIEW_PERCENT, e?.detail || {})
            this.trackingGoogle(SHORT_VIDEO_TRACKING_TYPE.VIEW_PERCENT, e?.detail || {})
            this.publishLoraEvents(SHORT_VIDEO_EVENT_NAMES.VIEW_VIDEO, e?.detail)
        })

        this.shadowRoot.addEventListener('toggle-like-video', (e) => {
            e.stopImmediatePropagation()
            this.toggleLikeVideo()
        })

        this.shadowRoot.addEventListener('shared', (e) => {
            e.stopImmediatePropagation()
            this.trackingIOT(SHORT_VIDEO_TRACKING_TYPE.SHARE)
            this.publishLoraEvents(SHORT_VIDEO_EVENT_NAMES.VIDEO_SHARE, e?.detail)
        })
        this.shadowRoot.addEventListener('cta-clicked', (e) => {
            e.stopImmediatePropagation()
            this.trackingIOT(SHORT_VIDEO_TRACKING_TYPE.CTA_CLICK, e?.detail || {})
            this.publishLoraEvents(SHORT_VIDEO_EVENT_NAMES.PRODUCT_CTA_CLICK, e?.detail || {})
        })
        this.shadowRoot.addEventListener('exit-fullscreen', (e) => {
            e.stopImmediatePropagation()
            this.publishLoraEvents(SHORT_VIDEO_EVENT_NAMES.EXIT_FULLSCREEN, e?.detail)
        })
        this.shadowRoot.addEventListener('update-sound-status', (e) => {
            e.stopImmediatePropagation()
            if (e?.detail?.muted) {
                this.publishLoraEvents(SHORT_VIDEO_EVENT_NAMES.VIDEO_MUTE)
            } else {
                this.publishLoraEvents(SHORT_VIDEO_EVENT_NAMES.VIDEO_UNMUTE)
            }
        })
        this.shadowRoot.addEventListener('video-pause', (e) => {
            e.stopImmediatePropagation()
            this.publishLoraEvents(SHORT_VIDEO_EVENT_NAMES.VIDEO_PAUSE)
        })
        this.shadowRoot.addEventListener('video-play', (e) => {
            e.stopImmediatePropagation()
            this.publishLoraEvents(SHORT_VIDEO_EVENT_NAMES.VIDEO_RESUME)
        })
        this.isRegistered = true
    }

    publishLoraEvents(eventName, opts) {
        let payload = opts
        if (eventName === SHORT_VIDEO_EVENT_NAMES.PRODUCT_CTA_CLICK) {
            payload = {
                product: {
                    cta_link: this.videoItem.ctaLink,
                    item_id: this.videoItem.products.length ? Number(this.videoItem.products[opts.index]?.id) : 0,
                    item_name: this.videoItem.products.length ? this.videoItem.products[opts.index]?.name : '',
                    image: opts.product?.image,
                    price: opts.product?.price,
                },
            }
        }
        emitShortVideoEvent(eventName, this.formatPayload(payload))
    }

    async sendAnswerForDefaultQuestion(answer) {
        if (this.httpInstance.repositories && this.videoId && answer) {
            try {
                const { code } = await this.httpInstance.repositories.shortVideo.anwserDefaultQuestion(
                    this.videoId,
                    this.videoItem.overlayData.id,
                    answer
                )
                if (code === STATUS_RESPONSES.SUCCESS) {
                    this.publishLoraEvents(SHORT_VIDEO_EVENT_NAMES.QA_DEFAULT, {
                        answered: answer,
                        question: this._shortVideo.qaDetail.questionDefault,
                    })

                    // Success
                    this.answeredDefaultQuestion = true

                    // check has follow up question
                    if (this.videoItem.overlayData.requiredFollowupInfo) {
                        this._shortVideo.showFollowUpQuestion()
                    } else {
                        setTimeout(() => {
                            this._shortVideo.showThankModal()
                        }, 1000)
                    }
                }
            } catch (e) {
                console.error(e)
            } finally {
                setTimeout(() => {
                    this.disabledButtonAnswer = false
                }, 1000)
            }
        }
    }

    async toggleLikeVideo() {
        if (this.httpInstance.repositories && this.videoId) {
            const payload = {
                id: this.videoId,
                trackedAt: Math.floor(Date.now() / 1000),
            }
            try {
                if (this.isLikedVideo) {
                    const { code } = await this.httpInstance.repositories.shortVideo.unLikeVideo(payload)
                    if (code === STATUS_RESPONSES.SUCCESS) {
                        this.totalLike = this.totalLike >= 1 ? this.totalLike - 1 : 0
                        await unlikeVideo(this.videoId, this.currentUser.uid)
                    }
                } else {
                    const { code } = await this.httpInstance.repositories.shortVideo.likeVideo(payload)
                    if (code === STATUS_RESPONSES.SUCCESS) {
                        this.totalLike++
                        await likeVideo(this.videoId, this.currentUser.uid)
                    }
                }
            } catch (e) {
                console.error(e)
            } finally {
                this.isLikedVideo = await isVideoLiked(this.videoId, this.currentUser.uid)
                requestAnimationFrame(() => {
                    this.updateShortVideoAttribute('total-like', this.totalLike)
                    this.updateShortVideoAttribute('is-liked-video', this.isLikedVideo)
                })
                window.dispatchEvent(
                    new CustomEvent('UPDATE_LIKE_VIDEO_DATA', {
                        detail: {
                            videoId: this.videoId,
                            playlistId: this.playlistId,
                            isLikedVideo: this.isLikedVideo,
                            totalLike: this.totalLike,
                        },
                        composed: true,
                        bubbles: true,
                    })
                )
            }
        }
    }

    async sendAnswerForFollowUpQuestion(answer) {
        if (this.httpInstance.repositories && this.videoId && answer) {
            try {
                const { code } = await this.httpInstance.repositories.shortVideo.anwserFollowUpQuestion(
                    this.videoId,
                    this.videoItem.overlayData.id,
                    answer
                )
                if (code === STATUS_RESPONSES.SUCCESS) {
                    this.publishLoraEvents(SHORT_VIDEO_EVENT_NAMES.QA_FOLLOW_UP, {
                        answered: answer,
                        question: this._shortVideo.qaDetail.questionFollowup,
                    })

                    // Success
                    this.answeredFollowupQuestion = true
                    setTimeout(() => {
                        this._shortVideo.showThankModal()
                    }, 1000)
                }
            } catch (e) {
                console.error(e)
            } finally {
                setTimeout(() => {
                    this.disabledButtonAnswer = false
                }, 1000)
            }
        }
    }

    updateData(data) {
        if (!this._shortVideo) {
            this._shortVideo = this.shadowRoot.querySelector('b-short-video')
        }
        this._shortVideo.updateData(data)
    }
    async fetchData(isPreload = true) {
        if (this.httpInstance.repositories && this.videoId) {
            let queryParams = ''
            if (this.playlistId) {
                queryParams += `playlistId=${this.playlistId}`
            }
            if (GlobalSettings.domainTracking) {
                queryParams += `${queryParams ? '&' : ''}domain=${GlobalSettings.domainTracking}`
            }
            try {
                const { code, data } = await this.httpInstance.repositories.shortVideo.detail({
                    queryParams: queryParams,
                    id: this.videoId,
                })
                if (code === STATUS_RESPONSES.SUCCESS) {
                    this.videoItem = data
                    this.enableLikeButton = this.videoItem?.enableLikeButton
                    this.displayLikeCount = this.videoItem?.displayLikeCount
                    this.totalLike = parseInt(this.videoItem?.totalLike)
                    this.currentUser = this.httpInstance.getCurrentUser()
                    this.isLikedVideo = await isVideoLiked(this.videoId, this.currentUser.uid)

                    if (this._shortVideo) this._shortVideo.videoItem = this.videoItem

                    if (!this.isSimple && this.videoItem.useCartIntegration) {
                        this.setBaseInfo()
                        if (this.videoItem.ecommerceSite?.value === ECOMMERCE_SITE.SHOPIFY) {
                            this.videoItem.products = await shopifyCart.syncProducts(this.videoItem.products || [])
                        } else if (this.videoItem.ecommerceSite?.value === ECOMMERCE_SITE.OTHER) {
                            this.isSyncingProduct = true
                            this.videoItem.products = await manualCart.syncProducts(
                                this.videoItem.products || [],
                                this.videoId,
                                this.playlistId
                            )
                        }
                    }
                    // For single embed video onlu
                    if (!this.playlistId) {
                        setTimeout(() => {
                            this.registerEvents()
                        }, 500)
                    }
                    // if (!this.isFullscreen && !this.playlistId) {
                    //     GlobalSettings.trackingIOT(
                    //         SHORT_VIDEO_TRACKING_TYPE.IMPRESSION,
                    //         this.playlistId,
                    //         [this.videoItem],
                    //         this.shadowRoot.host.tagName,
                    //         data.organizationId
                    //     )
                    // }
                    this.isPreload = isPreload
                    if (this.lazyLoad) {
                        this.setVideoData(this.isPreload)
                    } else {
                        this.render()
                    }
                } else if (code === STATUS_RESPONSES.VIDEO_NOT_FOUND) {
                    // Video not found
                    this.renderRemovedVideoLayout()
                }
            } catch (e) {
                console.error(e)
            }
        }
    }

    async renderRemovedVideoLayout() {
        const template = document.createElement('template')
        const childVideo = this.shadowRoot.querySelector('.lora-short-video')

        var context = {
            isEmpty: true,
        }
        if (this.playlistType === PLAYLIST_TYPE.GRID) {
            context.itemWrapper = this.itemWrapper
        }
        if (this.playlistType === PLAYLIST_TYPE.CAROUSEL) {
            context.itemWidth = this.itemWidth
        }
        if (this.isFullscreen) {
            context.isFullscreen = this.isFullscreen
            context.itemWidth = this.itemWidth
        }
        template.innerHTML = `${layoutTemplate(context)}`
        if (childVideo) {
            // We replace the current template (if any) with the empty template
            await this.shadowRoot.replaceChild(template.content.cloneNode(true), childVideo)
        } else {
            await this.shadowRoot.appendChild(template.content.cloneNode(true))
        }
        this.rendered = true
    }

    async checkViewerAnswerPoll() {
        try {
            const { code, data } = await this.httpInstance.repositories.shortVideo.getPollAnserResult(this.videoId)
            if (code === STATUS_RESPONSES.SUCCESS) {
                this.resultPoll = data
            }
            if (this.resultPoll.answered) {
                this.answered = true
                // this.updateStateSubmitedPoll()
                requestAnimationFrame(() => {
                    this.fetchPollAnswer({ collapsed: true })
                })
            }
        } catch (e) {
            console.error(e)
        }
    }

    async checkViewerAnswerQuestion() {
        try {
            const { code, data } = await this.httpInstance.repositories.shortVideo.getQuestionAndAnswerResult(
                this.videoId
            )
            if (code === STATUS_RESPONSES.SUCCESS) {
                this.answeredDefaultQuestion = data.answeredDefaultQuestion
                this.answeredFollowupQuestion = data.answeredFollowupQuestion
            }
        } catch (e) {
            console.error(e)
        }
    }

    async fetchPollAnswer({ forceFetch = false, collapsed = false } = {}) {
        try {
            let data = forceFetch ? null : this.resultPoll
            if (!data) {
                const response = await this.httpInstance.repositories.shortVideo.getPollAnserResult(this.videoId)
                data = response.data
                this.resultPoll = data
            }
        } catch (e) {
            console.error(e)
        }
    }

    async submitPoll() {
        if (!this.videoId || !this.pollingSelected || this.answered) {
            return
        }
        if (this.httpInstance.repositories && this.videoId) {
            try {
                const { code } = await this.httpInstance.repositories.shortVideo.submitPoll(
                    this.videoId,
                    this.pollingSelected
                )
                if (code === STATUS_RESPONSES.SUCCESS) {
                    this.publishLoraEvents(SHORT_VIDEO_EVENT_NAMES.POLL_ANSWER, {
                        answered: this.pollingSelected,
                        poll_title: this._shortVideo.pollDetail.title,
                    })

                    // Success
                    this.answered = true
                    this.trackingIOT(SHORT_VIDEO_TRACKING_TYPE.POLL_ANSWER)
                    // this.updateStateSubmitedPoll()
                    setTimeout(async () => {
                        await this.fetchPollAnswer({ forceFetch: true })
                        this._shortVideo.pollDetail = {
                            bgColor: this.videoItem.overlayData.backgroundColor,
                            textColor: this.videoItem.overlayData.textColor,
                            options: this.videoItem.overlayData.options,
                            title: this.videoItem.overlayData.title,
                            result: this.resultPoll,
                        }

                        if (!this.isFullscreen) return
                        this.dispatchEvent(
                            new CustomEvent('sync-state-poll-qna', {
                                detail: {
                                    poll: this._shortVideo.pollDetail || {},
                                    id: this.videoId,
                                    playlistId: this.playlistId,
                                    index: this.currentIndex.toString() || null,
                                },
                                composed: true,
                                bubbles: true,
                            })
                        )
                    }, 1000)
                }
            } catch (e) {
                console.error(e)
            }
        }
    }
    setShortVideoDataFromPlaylist(data) {
        if (!this.videoItem) {
            this.videoItem = data
        }
        this.videoType = this.videoItem ? this.videoItem.overlayType : null
        const isProcessing = this.videoItem?.videoStatus !== VIDEO_STATUS.ACTIVATED
        requestAnimationFrame(() => {
            this.updateShortVideoAttribute('video-type', this.videoType)
            this.updateShortVideoAttribute('processing', isProcessing)
        })

        this.registerEvents()
    }
    updateTrackingConfigs() {
        this.baseTrackingUrl = `${process.env.TRACKING_ENDPOINT}/api`
        this.trackingUrl = SHORT_VIDEO_API.TRACK_IOT
    }

    async trackingIOT(trackingType, opts) {
        const details = []
        const detailTracking = {
            shortVideoId: this.videoId,
            type: trackingType,
            count: 1,
            trackedAt: Math.floor(Date.now() / 1000),
            duration: Number(this.videoItem?.duration) || 0,
            ctaLink: trackingType === SHORT_VIDEO_TRACKING_TYPE.CTA_CLICK ? this.videoItem.ctaLink : '',
            countryCode: GlobalSettings.countryCode,
            productId:
                trackingType === SHORT_VIDEO_TRACKING_TYPE.CTA_CLICK
                    ? this.videoItem.products.length
                        ? Number(this.videoItem.products[opts.index]?.id)
                        : 0
                    : null,
        }
        details.push(detailTracking)

        const playlistData = getPlaylistData(this.playlistId)

        const trackingPayload = {
            playlistId: this.playlistId,
            details,
            organizationId: Number(this.videoItem?.organizationId) || playlistData?.data?.organizationId,
            playlistStoryType: Number(this.playlistType),
            device: GlobalSettings.device,
            domain: GlobalSettings.domainTracking,
        }

        this.trackingMetaPixel(trackingType, opts)
        this.trackingGoogle(trackingType, opts)

        if (GlobalSettings.isUseNewTracking) {
            // Using new tracking system
            // Using new tracking system
            this.updateTrackingConfigs()
        }
        if (this.httpInstance.repositories && this.videoId) {
            try {
                await this.httpInstance.repositories.shortVideo.trackIOT(
                    this.trackingUrl,
                    this.baseTrackingUrl,
                    trackingPayload
                )
            } catch (e) {
                console.error(e)
            }
        }
    }

    formatPayload(additionalData) {
        return {
            is_playlist: !!this.playlistId,
            organization_id: Number(this.videoItem?.organizationId),
            device: GlobalSettings.device,
            domain: GlobalSettings.domainTracking,
            ...(this.playlistId && {
                playlist: {
                    playlist_id: this.playlistId,
                    playlist_story_type: Object.keys(PLAYLIST_TYPE).find(
                        (key) => PLAYLIST_TYPE[key] === Number(this.playlistType)
                    ),
                },
            }),
            video: {
                video_id: this.videoId,
                video_title: this.videoItem?.title ? this.videoItem?.title : this.title,
                video_url: this.videoItem?.videoFile,
                thumbnail: this.thumbnail ? this.thumbnail : this.videoItem?.thumbnail,
            },
            ...additionalData,
        }
    }

    trackingGoogle(trackingType, opts) {
        if (typeof window.LoraStreamGoogleAnalytics !== 'undefined') {
            // You can use the fbq function here
            switch (trackingType) {
                case SHORT_VIDEO_TRACKING_TYPE.VIEW: {
                    window.LoraStreamGoogleAnalytics.trackEvent(ANALYTICS_EVENT.VIEW_VIDEO, {
                        video_id: this.videoId,
                        video_title: this.videoItem?.title ? this.videoItem?.title : this.title,
                        org_id: this.videoItem?.organizationId,
                    })
                    break
                }
                case SHORT_VIDEO_TRACKING_TYPE.SHARE: {
                    window.LoraStreamGoogleAnalytics.trackEvent(ANALYTICS_EVENT.SHARE_VIDEO, {
                        video_id: this.videoId,
                        video_title: this.videoItem?.title ? this.videoItem?.title : this.title,
                        org_id: this.videoItem?.organizationId,
                    })
                    break
                }
                case SHORT_VIDEO_TRACKING_TYPE.CLICK: {
                    window.LoraStreamGoogleAnalytics.trackEvent(ANALYTICS_EVENT.CLICK_ON_VIDEO, {
                        video_id: this.videoId,
                        video_title: this.videoItem?.title ? this.videoItem?.title : this.title,
                        org_id: this.videoItem?.organizationId,
                    })
                    break
                }
                case SHORT_VIDEO_TRACKING_TYPE.CTA_CLICK: {
                    window.LoraStreamGoogleAnalytics.trackEvent(ANALYTICS_EVENT.CLICK_CTA, {
                        cta_link: this.videoItem.ctaLink,
                        product_id: this.videoItem.products.length
                            ? Number(this.videoItem.products[opts.index]?.id)
                            : 0,
                        item_id: this.videoItem.products.length ? Number(this.videoItem.products[opts.index]?.id) : 0,
                        item_name: this.videoItem.products.length ? this.videoItem.products[opts.index]?.name : '',
                        product_name: this.videoItem.products.length ? this.videoItem.products[opts.index]?.name : '',
                        video_id: this.videoId,
                        video_title: this.videoItem?.title ? this.videoItem?.title : this.title,
                        org_id: this.videoItem?.organizationId,
                    })
                    break
                }
                case SHORT_VIDEO_TRACKING_TYPE.POLL_ANSWER: {
                    window.LoraStreamGoogleAnalytics.trackEvent(ANALYTICS_EVENT.CLICK_POLL, {
                        video_id: this.videoId,
                        video_title: this.videoItem?.title ? this.videoItem?.title : this.title,
                        org_id: this.videoItem?.organizationId,
                    })
                    break
                }
                case SHORT_VIDEO_TRACKING_TYPE.QNA_CLICK: {
                    window.LoraStreamGoogleAnalytics.trackEvent(ANALYTICS_EVENT.CLICK_QUESTION_AND_ANSWER, {
                        video_id: this.videoId,
                        video_title: this.videoItem?.title ? this.videoItem?.title : this.title,
                        org_id: this.videoItem?.organizationId,
                    })
                    break
                }

                case SHORT_VIDEO_TRACKING_TYPE.VIEW_PERCENT: {
                    if (opts.video_percent && !this.videoPercentTrackedGoogle.includes(opts.video_percent)) {
                        if (this.playlistId) {
                            window.LoraStreamGoogleAnalytics.trackEvent(ANALYTICS_EVENT.VIEW_VIDEO_IN_PLAYLISTT, {
                                ...opts,
                                video_id: this.videoId,
                                playlist_id: this.playlistId,
                                video_title: this.videoItem?.title ? this.videoItem?.title : this.title,
                                video_url: this.videoItem?.videoFile,
                                org_id: this.videoItem?.organizationId,
                            })
                        } else {
                            window.LoraStreamGoogleAnalytics.trackEvent(ANALYTICS_EVENT.VIEW_VIDEO_INVIDIUAL, {
                                ...opts,
                                video_id: this.videoId,
                                video_title: this.videoItem?.title ? this.videoItem?.title : this.title,
                                video_url: this.videoItem?.videoFile,
                                org_id: this.videoItem?.organizationId,
                            })
                        }
                        this.videoPercentTrackedGoogle.push(opts.video_percent)
                    }
                    break
                }
            }
        }
    }

    trackingMetaPixel(trackingType, opts) {
        // <!-- Meta Pixel Code -->
        if (typeof fbq !== 'undefined') {
            // You can use the fbq function here
            switch (trackingType) {
                case SHORT_VIDEO_TRACKING_TYPE.VIEW: {
                    fbq('trackSingleCustom', META_ID, ANALYTICS_EVENT.VIEW_VIDEO, {
                        video_id: this.videoId,
                        organization_id: this.videoItem?.organizationId,
                    })
                    break
                }
                case SHORT_VIDEO_TRACKING_TYPE.SHARE: {
                    fbq('trackSingleCustom', META_ID, ANALYTICS_EVENT.SHARE_VIDEO, {
                        video_id: this.videoId,
                        organization_id: this.videoItem?.organizationId,
                    })
                    break
                }
                case SHORT_VIDEO_TRACKING_TYPE.CLICK: {
                    fbq('trackSingleCustom', META_ID, ANALYTICS_EVENT.CLICK_ON_VIDEO, {
                        video_id: this.videoId,
                        organization_id: this.videoItem?.organizationId,
                    })
                    break
                }
                case SHORT_VIDEO_TRACKING_TYPE.CTA_CLICK: {
                    fbq('trackSingleCustom', META_ID, ANALYTICS_EVENT.CLICK_CTA, {
                        video_id: this.videoId,
                        cta_link: this.videoItem.ctaLink,
                        product_id: this.videoItem.products.length
                            ? Number(this.videoItem.products[opts.index]?.id)
                            : 0,
                        organization_id: this.videoItem?.organizationId,
                    })
                    break
                }
                case SHORT_VIDEO_TRACKING_TYPE.POLL_ANSWER: {
                    fbq('trackSingleCustom', META_ID, ANALYTICS_EVENT.CLICK_POLL, {
                        video_id: this.videoId,
                        organization_id: this.videoItem?.organizationId,
                    })
                    break
                }
                case SHORT_VIDEO_TRACKING_TYPE.QNA_CLICK: {
                    fbq('trackSingleCustom', META_ID, ANALYTICS_EVENT.CLICK_QUESTION_AND_ANSWER, {
                        video_id: this.videoId,
                        organization_id: this.videoItem?.organizationId,
                    })
                    break
                }

                case SHORT_VIDEO_TRACKING_TYPE.VIEW_PERCENT: {
                    if (opts.video_percent && !this.videoPercentTracked.includes(opts.video_percent)) {
                        if (this.playlistId) {
                            fbq('trackSingleCustom', META_ID, ANALYTICS_EVENT.VIEW_VIDEO_IN_PLAYLISTT, {
                                ...opts,
                                video_id: this.videoId,
                                playlist_id: this.playlistId,
                                video_title: this.videoItem.title,
                                video_url: this.videoItem?.videoFile,
                                organization_id: this.videoItem?.organizationId,
                            })
                        } else {
                            fbq('trackSingleCustom', META_ID, ANALYTICS_EVENT.VIEW_VIDEO_INVIDIUAL, {
                                ...opts,
                                video_id: this.videoId,
                                video_title: this.videoItem.title,
                                video_url: this.videoItem?.videoFile,
                                organization_id: this.videoItem?.organizationId,
                                organization_id: this.videoItem?.organizationId,
                            })
                        }
                        this.videoPercentTracked.push(opts.video_percent)
                    }
                    break
                }
            }
        }
        // <!-- End Meta Pixel Code -->
    }

    handleSyncLikeData() {
        window.addEventListener('UPDATE_LIKE_VIDEO_DATA', (event) => {
            const { videoId, playlistId, isLikedVideo, totalLike } = event?.detail
            if (videoId === this.videoId) {
                this.isLikedVideo = isLikedVideo
                this.totalLike = parseInt(totalLike)
                if (this._shortVideo) {
                    this._shortVideo.updateVideoData({
                        url: this.videoItem?.videoFile,
                        isPreload: this.isPreload,
                        enableLikeButton: this.enableLikeButton,
                        displayLikeCount: this.displayLikeCount,
                        totalLike: this.totalLike,
                        isLikedVideo: this.isLikedVideo,
                    })
                    requestAnimationFrame(() => {
                        this.updateShortVideoAttribute('lazyload', false)
                        this.updateShortVideoAttribute('enable-like-button', this.enableLikeButton)
                        this.updateShortVideoAttribute('display-like-count', this.displayLikeCount)
                        this.updateShortVideoAttribute('total-like', this.totalLike)
                    })
                }
            }
        })
    }

    async render() {
        this.currentUser = this.httpInstance.getCurrentUser()
        this.isLikedVideo = await isVideoLiked(this.videoId, this.currentUser.uid)
        this.enableLikeButton = this.videoItem?.enableLikeButton
        this.displayLikeCount = this.videoItem?.displayLikeCount
        this.totalLike = parseInt(this.videoItem?.totalLike)
        var context = {
            videoId: this.videoId,
            title: this.playlistType ? this.title : this.videoItem?.title,
            url: this.videoItem ? this.videoItem?.videoFile : '',
            featureImage: this.videoItem ? this.videoItem?.thumbnail : '',
            itemWrapper: this.itemWrapper,
            gutters: this.gutters,
            itemWidth: this.itemWidth,
            isFullscreen: this.isFullscreen,
            isForceNewTab: this.isForceNewTab,
            currentIndex: this.currentIndex,
            videoHeight: this.videoHeight,
            displayStyle: this.displayStyle,
            isEmpty: false,
            wrapperLayout: this.wrapperLayout,
            group: this.group,
            isSimple: this.isSimple,
            videoType: this.videoItem ? this.videoItem.overlayType : '',
            lazyload: this.lazyLoad,
            featureImageUrl: this.thumbnail,
            autoplay: this.autoplay,
            useCartIntegration: this.videoItem ? this.videoItem.useCartIntegration : false,
            isProcessing: this.videoItem ? this.videoItem.videoStatus !== VIDEO_STATUS.ACTIVATED : false,
            enableFullscreen: this.enableFullscreen,
            pipStyle: this.pipStyle,
            uuid: this.uuid,
            organizationId: this.videoItem?.organizationId || this.organizationId,
            tagName: this.customTagName,
            minVideoHeightToShowButtons: this.minVideoHeightToShowButtons,
            enableLikeButton: this.enableLikeButton,
            displayLikeCount: this.displayLikeCount,
            totalLike: this.totalLike,
            isLikedVideo: this.isLikedVideo,
        }
        this.shadowRoot.innerHTML = `${layoutTemplate(context)}`
        appendCommonStyling(this.shadowRoot)

        this.rendered = true

        if (this.isFullscreen) {
            // Remove border radius at the corner for fullscreen mode
            const { shadowRoot } = this.shadowRoot.querySelector('b-short-video')

            const videoElement = shadowRoot.querySelector('.lora-short__video')
            if (videoElement) {
                videoElement.style.borderRadius = '0px'
            }

            const overlayElement = shadowRoot.querySelector('.lora-short__overlay')
            if (overlayElement) {
                overlayElement.style.borderRadius = '0px'
            }
        }
        this.shadowRoot.addEventListener('tracking-fullscreen', (e) => {
            e.stopImmediatePropagation()
            this.trackingIOT(SHORT_VIDEO_TRACKING_TYPE.CLICK)
            this.publishLoraEvents(SHORT_VIDEO_EVENT_NAMES.ENTER_FULLSCREEN, e?.detail)
        })
        if (this.lazyLoad) {
            this._shortVideo = this.shadowRoot.querySelector('b-short-video')
            requestAnimationFrame(() => {
                this.updateShortVideoAttribute('item-width', this.itemWidth)
                this.updateShortVideoAttribute('autoplay', this.autoplay)
                this.updateShortVideoAttribute('fullscreen', this.isFullscreen)
                this.updateShortVideoAttribute('no-action-hover', this.noActionHover)
                this.updateShortVideoAttribute('loop', this.loop)
                this.updateShortVideoAttribute('muted', this.muted, true)
                this.updateShortVideoAttribute('video-height', this.videoHeight ? `${this.videoHeight}` : '480px')
                this.updateShortVideoAttribute('polling-selected', this.pollingSelected)
                this.updateShortVideoAttribute('group', this.group)
                this.updateShortVideoAttribute('simple', this.isSimple)
                this.updateShortVideoAttribute('pip-style', this.pipStyle)
                this.updateShortVideoAttribute('uuid', this.uuid)
                this.updateShortVideoAttribute('tag-name', this.customTagName)
                this.updateShortVideoAttribute('enable-like-button', this.enableLikeButton)
                this.updateShortVideoAttribute('display-like-count', this.displayLikeCount)
                this.updateShortVideoAttribute('total-like', this.totalLike)
            })
            this._shortVideo.addEventListener('fetch-detail', () => {
                this.fetchData(false)
            })
        } else {
            this.registerEvents()
        }
        if (!this.isSimple) {
            this.handleInternalEvents()
        }
        this.handleSyncLikeData()
    }
}
window.customElements.define('video-embed', LoraShortVideo)
